export default __webpack_public_path__ + "static/media/finance-guide-lease.3d0be878.svg";